import { useCrumbs } from "@/components/layout/CrumbsContext";
import { AccountView } from "@/components/plan-audit/AccountView";

export function AccountPage() {
  useCrumbs([{ label: "Account" }, { label: "Claude Code" }]);
  return (
    <>
      <div className="pa-page-head">
        <div>
          <h1>Account</h1>
          <p>
            Microsoft SSO is who you are; the Claude connection is what a run executes on. They are
            separate on purpose.
          </p>
        </div>
      </div>
      <AccountView />
    </>
  );
}
